import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  TableContainer,
  Text,
  Flex,
  Td,
  Select,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import Pagination from "../../../../defaultComponents/pagination";
import {
  CaptionFormater,
  ToLocaleFormat,
} from "../../../../defaultFunctions/formaters";
import { goToListadeAssinaturasVinculadas } from "../../../../routes/coordinator";
import { ClientInterface } from "../../../../interfaces/defaultInterfaces";
import VendasRecorrentesApi from "../../../../services/vendasRecorrentesApi";
import { customColors } from "../../../../atoms/customColors";
import { HamburgerIcon } from "@chakra-ui/icons";
import { FaLock, FaUnlock, FaAlignJustify } from "react-icons/fa";
import { toast } from "react-toastify";
import ClientApi from "../../../../services/clientApi";
import { useNavigate } from "react-router-dom";
interface IListPlanos {
  id: number;
  nome: string;
  cliente: ClientInterface;
  descricao: string;
  frequencia: string;
  duracao: number;
  intervalo: number;
  tolerancia: number;
  valor: number;
  taxa: number;
  idCliente: number;
  idPlano: number;
  apiOut: boolean | null;
}

function TablePlanosRecorrencia({ idCliente }: any) {
  const [planos, setPlanos] = useState(Array<IListPlanos>);
  const colors = useRecoilState(customColors)[0];

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const refresh = useRecoilState(refreshGlobal)[0];
  const formatDuracao = (
    duracao: number | string,
    frequencia: string
  ): string => {
    switch (frequencia) {
      case "monthly":
        return `${duracao} Meses`;
      case "daily":
        return `${duracao} Dias`;
      case "weekly":
        return `${duracao} Semanas`;
      default:
        return `${duracao} Anos`;
    }
  };
  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
    }
  }, [pages]);

  const [isApiOut, setIsApiOut] = useState(false);
  const navigate = useNavigate();
  async function getClientByID() {
    try {
      const response = await ClientApi.getClientPerId(idCliente);
      // console.log("response do cliente", response);
      setIsApiOut(response.apiout);
    } catch (error) {
      console.log("error :", error);
    }
  }

  async function getPlanos() {
    try {
      const response = await VendasRecorrentesApi.getListaPlanosRecorrencia(
        currentPage,
        pageSize,
        idCliente
      );
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
      getClientByID();
      // console.log("response", response.data);
      setPlanos(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  async function activateApiOut(idPlano: number) {
    try {
      await VendasRecorrentesApi.apioutChangePermission(
        idPlano,
        true,
        idCliente
      );
      toast.success("Plano Ativado para ApiOut com Sucesso!");
      getPlanos();
    } catch (error) {
      toast.error(
        "Falha ao Ativar Plano para ApiOut, Verifique se não há outro plano ativo no momento!"
      );
      console.log(error);
    }
  }

  async function desactivateApiOut(idPlano: number) {
    try {
      await VendasRecorrentesApi.apioutChangePermission(
        idPlano,
        false,
        idCliente
      );
      toast.success("Plano Desativado para ApiOut com Sucesso!");
      getPlanos();
    } catch (error) {
      toast.error("Falha ao desativar o plano!");
      console.log(error);
    }
  }

  useEffect(() => {
    getPlanos();
  }, [refresh, currentPage, pageSize, idCliente]);

  return (
    <>
      <Flex justify="center" mb={4}>
        <Text fontWeight={"bold"} fontSize={"20px"}>
          Lista de Planos para Assinaturas
        </Text>
      </Flex>

      <Flex flexDir={"column"}>
        <TableContainer
          overflowY={"auto"}
          overflowX={"auto"}
          h={"64vh"}
          w={"84vw"}
        >
          <Table variant="striped">
            <Thead h="60px" zIndex={1} position="sticky" top="0">
              <Tr>
                <Th
                  borderRadius={"8px 0 0 8px"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Nome do Plano
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Cliente
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Frequência
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Duração
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Valor do Plano
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Taxa do Plano
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Intervalo
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Descrição
                </Th>
                {isApiOut && (
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Status Api Out
                  </Th>
                )}

                <Th
                  borderRadius={isApiOut ? "0 8px 8px 0" : undefined}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Opções
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {planos ? (
                planos.map((item) => {
                  return (
                    <Tr key={item.id}>
                      <Td borderRadius={"8px 0px 0px 8px"}>
                        {CaptionFormater(item.nome)}
                      </Td>
                      <Td
                        maxW="280px"
                        wordBreak="break-word"
                        whiteSpace={"pre-wrap"}
                      >
                        {item?.cliente?.isCnpj === true
                          ? CaptionFormater(item?.cliente?.razaoSocial)
                          : `${CaptionFormater(
                              item?.cliente?.nome
                            )} ${CaptionFormater(item?.cliente?.sobrenome)}`}
                      </Td>
                      <Td>
                        {item.frequencia === "monthly"
                          ? "Mensal"
                          : item.frequencia === "daily"
                          ? "Diária"
                          : item.frequencia === "weekly"
                          ? "Semanal"
                          : "Anual"}{" "}
                      </Td>
                      <Td>
                        {item.frequencia === "monthly"
                          ? `${item.duracao} Meses`
                          : item.frequencia === "daily"
                          ? `${item.duracao} Dias`
                          : item.frequencia === "weekly"
                          ? `${item.duracao} Semanas`
                          : `${item.duracao} Anos`}
                      </Td>
                      <Td>
                        {item.valor
                          ? ToLocaleFormat(item.valor / 100)
                          : "R$ 0,00"}
                      </Td>
                      <Td>
                        {item.taxa
                          ? ToLocaleFormat(item.taxa / 100)
                          : "R$ 0,00"}
                      </Td>
                      <Td>
                        {item.intervalo} em {item.intervalo}{" "}
                        {item.frequencia === "monthly"
                          ? "Meses"
                          : item.frequencia === "daily"
                          ? "Dias"
                          : item.frequencia === "weekly"
                          ? "Semanas"
                          : "Anos"}{" "}
                        duração {formatDuracao(item.duracao, item.frequencia)}
                      </Td>
                      <Td borderRadius={"0 8px 8px 0"}>
                        {CaptionFormater(item.descricao)}
                      </Td>
                      {isApiOut && (
                        <>
                          <Td>
                            {item.apiOut === true ? "Ativo" : "Desativado"}
                          </Td>
                          <Td>
                            <Menu>
                              <MenuButton
                                as={IconButton}
                                aria-label="Options"
                                icon={<HamburgerIcon />}
                                bgColor={colors.BLUEMONEDDBUTTONS}
                                color={colors.WHITE}
                                size={"sm"}
                              />
                              <MenuList>
                                {item.apiOut === true ? (
                                  <MenuItem
                                    icon={<FaLock />}
                                    onClick={() => desactivateApiOut(item.id)}
                                  >
                                    Desativar Apiout
                                  </MenuItem>
                                ) : (
                                  <MenuItem
                                    icon={<FaUnlock />}
                                    onClick={() => activateApiOut(item.id)}
                                  >
                                    Ativar ApiOut
                                  </MenuItem>
                                )}
                                <MenuItem
                                  icon={<FaAlignJustify />}
                                  onClick={() =>
                                    goToListadeAssinaturasVinculadas(
                                      navigate,
                                      idCliente,
                                      item.idPlano
                                    )
                                  }
                                >
                                  Planos Relacionados
                                </MenuItem>
                              </MenuList>
                            </Menu>
                          </Td>
                        </>
                      )}
                    </Tr>
                  );
                })
              ) : (
                <></>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        <Flex width={"100%"} justifyContent="center" mt={8}>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pages={pages}
            pageSize={pageSize}
          />
          <Select
            value={pageSize}
            onChange={onChangeSize}
            size="sm"
            ml={5}
            maxW="70px"
            borderRadius="6px"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
          </Select>
        </Flex>
      </Flex>
    </>
  );
}
export default TablePlanosRecorrencia;
